var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-wraper"},[_c('Header'),(_vm.data.content)?_c('div',{staticClass:"about",domProps:{"innerHTML":_vm._s(_vm.data.content)}}):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }